import Component from 'flarum/common/Component';
export default class ProgressBar extends Component {
  view() {
    let className = ['UiKit-ProgressBar'];
    if (this.attrs.className) className.push(this.attrs.className);
    if (this.attrs.mini) className.push('UiKit-ProgressBar--mini');
    if (this.attrs.fancy) className.push('UiKit-ProgressBar--fancy');
    if (this.attrs.alternate) className.push('UiKit-ProgressBar--alternate');
    return m("div", {
      className: className.join(' ')
    }, m("div", {
      className: "UiKit-ProgressBar-bar",
      style: {
        width: "".concat(this.getProgress(), "%")
      }
    }));
  }
  getProgress() {
    return this.attrs.progress;
  }
}
flarum.reg.add('sycho-uikit', 'common/components/ProgressBar', ProgressBar);